import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface InsulationProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Insulation: React.FC<InsulationProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [insulation, set_insulation] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Insulation']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Insulation': [b.values?.['Interior']?.['Insulation']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Insulation';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(insulation)}
                />
            ) : (
                <MoneyBox
                    id={'insulation'}
                    allowNegative={false}
                    value={insulation}
                    onChange={(value) => set_insulation(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
